import styled from 'styled-components';

import Heading from 'components/_core/Heading';
import IconCircle from 'components/_core/IconCircle';
import Text from 'components/_core/Text';

export const Title = styled(Heading).attrs({ size: 'lg' })`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacings.abs40}px;
`;

export const TermsAgreementContainer = styled.div`
  padding: ${({ theme }) =>
    `${theme.spacings.abs16}px ${theme.spacings.abs24}px ${theme.spacings.abs16}px ${theme.spacings.abs32}px`};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TermsAgreementLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const TermsAgreementLabelText = styled(Text).attrs({
  size: 'sm',
})``;

export const DownloadIcon = styled(IconCircle).attrs({
  backgroundColor: 'ctaBlue.3',
  color: 'ctaBlue.-1',
  name: 'download',
  size: '40px',
})``;
